import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { OriginationBorrower } from '@ld.consumer-portal/models';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-switch-borrower-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './switch-borrower-modal.component.html',
  styleUrl: './switch-borrower-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchBorrowerModalComponent {
  readonly borrowers = input.required<OriginationBorrower[]>();

  readonly currentBorrowerId = input<string>('');

  readonly select = output<OriginationBorrower>();

  readonly cancel = output<void>();

  protected readonly selectedBorrower = signal<OriginationBorrower | null>(null);

  protected onSelectBorrower(borrower: OriginationBorrower): void {
    this.selectedBorrower.set(borrower);
  }

  protected onConfirm(): void {
    const selected = this.selectedBorrower();
    if (selected) {
      this.select.emit(selected);
    }
  }

  protected onCancel(): void {
    this.cancel.emit();
  }

  protected getBorrowerDisplayName(borrower: OriginationBorrower): string {
    return `${borrower.firstName} ${borrower.lastName}`.trim();
  }

  protected isCurrentBorrower(borrower: OriginationBorrower): boolean {
    return borrower.id === this.currentBorrowerId();
  }

  protected isSelected(borrower: OriginationBorrower): boolean {
    return this.selectedBorrower()?.id === borrower.id;
  }
}
